module.exports = __webpack_public_path__ + "static/media/Bag.87d1c49b.svg";